<template>
  <FlotoAnchorLink :aria-label="$t('claim')" @click="triggerAction">
    <MIcon name="user" class="action-menu-icon" />
    <span class="mx-1 action-menu-text">
      {{ $t('claim') }}
    </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="user" class="w-full text-primary" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_claim', {
            resource: $tc(moduleName, selectedItemIds.length),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'Claim',
  props: {
    moduleName: { type: String, required: true },
    selectedItemIds: { type: Array, required: true },
    handleClaimRequests: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleClaimRequests) {
        this.processing = true
        this.handleClaimRequests()
          .then(() => {
            this.showModal = false
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
  },
}
</script>
